// extracted by mini-css-extract-plugin
export default {"send-to-email__modal__header":"send-to-email_send-to-email__modal__header__afEzr","send-to-email__modal__actions":"send-to-email_send-to-email__modal__actions__WOyEO"};